import React, { Component } from "react";
import { track, membershipLevel } from "../helpers/analytics";
import withRouter from "../helpers/withRouter";
import { emitter } from "../pages/home/context/event";
import introJs from "intro.js";
import { Link } from "react-router-dom";
import { FiCamera, FiStar } from "react-icons/fi";

const CameraIcon: any = FiCamera;
const NudeIcon: any = FiStar;

interface InputBoxProps {
  onInputChange: (inputField: string) => void;
  onGenerateImage: (
    inputField: string,
    userReferenceImageData?: string,
    requestType?: "selfie" | "nude" | "custom"
  ) => void;
  updateParams: any;
  higherLevelProps: any;
  prompt: any;
  send: any;
  userPlan: string;
  haveAnyPrompt: boolean;
  sample_prompts: { sample_prompt: string; plan: string }[];
  book_talk_prompts: { sample_prompt: string; plan: string }[];
}

interface InputBoxState {
  userInput: string;
  userReferenceImageData: string;
  imageRequestType: "selfie" | "nude" | "custom";
  plusToggle: string;
  isModalOpen: boolean;
  requiredTier: string;
}

interface tiersInNumbers {
  subscriber: number;
  patron: number;
  premium: number;
}

const tiersInNumbers: tiersInNumbers = {
  subscriber: 1,
  patron: 2,
  premium: 3,
};

class InputBox extends React.Component<InputBoxProps, InputBoxState> {
  state: InputBoxState = {
    userInput: "",
    userReferenceImageData: "",
    imageRequestType: "custom",
    plusToggle: "",
    isModalOpen: false,
    requiredTier: "",
  };

  constructor(props: InputBoxProps) {
    super(props);
    if (this.props.prompt && this.props.prompt !== "") {
      this.state.userInput = this.props.prompt;
      if (this.props.send != null && this.props.send != "false") {
        setTimeout(() => {
          this.onSend();
          localStorage.setItem("pre_signup_sent", "true");
        }, 500);
      }
    }
  }

  private handleSendEvent = () => this.onSend();
  private trackSelfieOffer = () => {
    if (!this.props.haveAnyPrompt) return;
    const tier = membershipLevel(this.props.userPlan);
    track('selfie_access_view', { membership_level: tier, enabled: tier === 'patron' || tier === 'premium' });
  };

  componentDidMount(): void {
    emitter.on("onSend", this.handleSendEvent);
    this.trackSelfieOffer();
  }

  componentWillUnmount(): void {
    emitter.off("onSend", this.handleSendEvent);
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if (prevProps.userPlan !== this.props.userPlan || prevProps.haveAnyPrompt !== this.props.haveAnyPrompt) this.trackSelfieOffer();
    // This code runs when the component updates (similar to useEffect with props or state dependencies)

    if (this.props.prompt !== prevProps.prompt) {
      this.setState({ userInput: this.props.prompt });
    }
  }

  handleKeyPress = (event: { key: string }) => {
    if (event.key === "Enter") {
      this.onSend();
    }
  };

  userInput(userInput: string) {
    this.setState({ userInput });
  }

  openModal = (tier: string) => {
    this.setState({ isModalOpen: true, requiredTier: tier });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false, requiredTier: "" });
  };

  renderModal() {
    const { isModalOpen } = this.state;

    if (!isModalOpen) return null;
  }
  onSend() {
    if (!localStorage.getItem("token")) {
      console.log(this.props.prompt, "\n", this.state.userInput);
      console.log(this.props.prompt == this.state.userInput);
      if (
        this.state.userInput != localStorage.getItem("allowed_presignup_prompt")
      ) {
        return (window.location.href = `${process.env.REACT_APP_REST_API_URI}/login`);
      }
    }

    // Once a request type is selected, the normal send controls should submit
    // the image request instead of sending the prompt as ordinary chat text.
    if (this.state.imageRequestType !== "custom") {
      return this.onGenerateImageRequest();
    }

    const prompt = this.props.sample_prompts.find(
      (value) => value.sample_prompt === this.state.userInput
    );
    const bookTalkPrompt = this.props.book_talk_prompts.find(
      (value) => value.sample_prompt === this.state.userInput
    );

    // 2) If *either* matched, pick the one that exists, and then use its `.plan`
    if (prompt || bookTalkPrompt) {
      // By this point, at least one is non‐undefined. Let’s pick the one that matched:
      const matchedPrompt = prompt || bookTalkPrompt!;
      // (we use `!` on bookTalkPrompt only because this line only runs if prompt is falsey, forcing
      //  bookTalkPrompt to be non‐undefined.)

      const userPlan =
        this.props.userPlan === "Basic"
          ? "subscriber"
          : this.props.userPlan === "Plus"
          ? "patron"
          : "premium";

      // Now it’s safe to do matchedPrompt.plan
      if (
        tiersInNumbers[matchedPrompt.plan as keyof typeof tiersInNumbers] >
          tiersInNumbers[userPlan as keyof typeof tiersInNumbers] &&
        localStorage.getItem("token")
      ) {
        emitter.emit("upgradePopup", matchedPrompt.plan);
        return;
      }
    }
    this.props.onInputChange(this.state.userInput);

    this.setState({ userInput: "", imageRequestType: "custom" });
  }

  onGenerateImageRequest = () => {
    if (!localStorage.getItem("token")) {
      console.log(this.props.prompt, "\n", this.state.userInput);
      if (
        this.state.userInput != localStorage.getItem("allowed_presignup_prompt")
      ) {
        return (window.location.href = `${process.env.REACT_APP_REST_API_URI}/login`);
      }
    }

    if (!this.state.userInput.trim()) {
      return;
    }

    this.props.onGenerateImage(
      this.state.userInput,
      this.state.userReferenceImageData || undefined,
      this.state.imageRequestType
    );
    this.setState({ userInput: "", imageRequestType: "custom" });
  };

  onImageRequest = (requestType: "selfie" | "nude") => {
    const plan = this.props.userPlan.toLowerCase();
    const canRequestSelfie = plan === "plus" || plan === "premium";
    const canRequestNude = plan === "premium";

    const allowed = requestType === "selfie" ? canRequestSelfie : canRequestNude;
    track(`${requestType}_button_click`, {
      membership_level: membershipLevel(plan),
      outcome: allowed ? "allowed" : "membership_required"
    });

    if (requestType === "selfie" && !canRequestSelfie) {
      return;
    }
    if (requestType === "nude" && !canRequestNude) {
      return;
    }

    const promptPrefix =
      requestType === "nude" ? "Request a nude: " : "Request a selfie: ";

    this.setState({
      userInput: this.state.userInput.trim()
        ? `${promptPrefix}${this.state.userInput.trim()}`
        : promptPrefix,
      imageRequestType: requestType,
    });
  };

  onReaderReferenceSelected = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (
      !["image/png", "image/jpeg"].includes(file.type) ||
      file.size > 5 * 1024 * 1024
    ) {
      window.alert("Please choose a PNG or JPEG image smaller than 5 MB.");
      event.target.value = "";
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === "string") {
        this.setState({ userReferenceImageData: reader.result });
      }
    };
    reader.readAsDataURL(file);
  };

  plusIcon() {
    const action: string = this.state.plusToggle == "action" ? "null" : "new";
    this.props.updateParams({
      action,
    });
    this.setState({
      plusToggle: this.state.plusToggle == "action" ? "null" : "action",
    });

    setTimeout(() => {
      const hasSeenTour = localStorage.getItem("hasSeenChatTourMobile");
      if (!hasSeenTour) {
        const isMobile = window.innerWidth <= 768;
        if (isMobile) {
          introJs()
            .setOptions({
              steps: [
                {
                  element: "#mobile-personality-mode",
                  intro: "Access chat prompts designed for fun conversations.",
                },
                {
                  element: "#mobile-booktalk-mode",
                  intro:
                    "Access bonus short stories, novel chapters, and chat with the characters about their book.",
                },
              ],
            })
            .start();
        }
        localStorage.setItem("hasSeenChatTourMobile", "true");
      }
    }, 1000);
  }

  render() {
    if (!this.props.haveAnyPrompt) return <></>;
    const plan = this.props.userPlan.toLowerCase();
    const canRequestSelfie = plan === "plus" || plan === "premium";
    const canRequestNude = plan === "premium";

    return (
      <>
        <div className="composer-row">
          <div className="image-request-actions" aria-label="Image requests">
            <span className="image-request-control">
              <button
                type="button"
                className={`image-request-button ${
                  canRequestSelfie ? "available" : "disabled"
                }`}
                aria-label="Request a selfie"
                aria-describedby="request-selfie-tooltip"
                disabled={!canRequestSelfie}
                onClick={() => this.onImageRequest("selfie")}
              >
                <CameraIcon aria-hidden="true" />
              </button>
              <span
                id="request-selfie-tooltip"
                className="image-request-tooltip"
                role="tooltip"
              >
                <strong>Request a selfie</strong>
                <span>Patron level</span>
              </span>
            </span>
            <span className="image-request-control">
              <button
                type="button"
                className={`image-request-button ${
                  canRequestNude ? "available" : "disabled"
                }`}
                aria-label="Request a nude"
                aria-describedby="request-nude-tooltip"
                disabled={!canRequestNude}
                onClick={() => this.onImageRequest("nude")}
              >
                <NudeIcon aria-hidden="true" />
              </button>
              <span
                id="request-nude-tooltip"
                className="image-request-tooltip"
                role="tooltip"
              >
                <strong>Request a Nude</strong>
                <span>Premium Level</span>
              </span>
            </span>
          </div>

          <div className="flex items-center input-box">
            <span className="hidden lg:block cursor-pointer opacity-90 add"></span>
            <span
              id="mobile-element-1"
              className="block lg:hidden cursor-pointer opacity-90 add"
              onClick={() => this.plusIcon()}
            >
              <img src="/assets/images/plus.svg" alt="" className="send-active" />
            </span>
            <input
              type="text"
              placeholder="Type a message here."
              value={this.state.userInput}
              onChange={(event) => this.userInput(event.target.value)}
              onKeyPress={this.handleKeyPress}
            />

            <div className="composer-actions">
            <span
              className="cursor-pointer opacity-90 send"
              onClick={() => this.onSend()}
            >
              <img src="/assets/images/send.svg" alt="" className="send-active" />
            </span>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(InputBox);
